import { Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  GetCustomerCurrentTime,
  GetMachineListData,
  getPartId,
  readOperatorList,
  GetUtilizationDetailData,
  pad,
  GetMachineListDataMsd
} from "../../services/common/cnc_apis";

import moment from "moment";
import { CSSTransition } from "react-transition-group";
import { UpdateAppConfig } from "../../services/redux/reducers/app";
import MachineDetailPage from "../CNCPages/machineDetailPage/MachineDetailPage";
import MachineItem from "../CNCPages/MainPage/MachineItem_Grid/MachineItemMsd";
import "./MachineScheduleDashboards.css";
import MonthlyUtilization from "./MonthlyUtilization";
import JobCardsPresentation from "./JobCardsPresentation";

const MachineScheduleDashboards = (props) => {
  const dispatch = useDispatch();
  const appData = useSelector((state) => state.app);
  const authData = useSelector((x) => x.authService);
  const { customer_id, machine_id } = props.match.params;
  const { security_level } = authData;
  const [operatorList, setOperatorList] = useState([]);
  const cncService = useSelector((x) => x.cncService);
  const customerInfo = cncService.customerInfoList[customer_id];
  const timezone = customerInfo["timezone"];

  const { screenSize } = appData;
  const [machineId, setMachineId] = useState("");
  const [partId, setPartId] = useState();
  const [partIds, setPartIds] = useState([]);
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [monthlyUtilizations, setMonthlyUtilizations] = useState([]);

  const [selectedMachine, setSelectedmachine] = useState("");
  const [showSpin, setShowSpin] = useState(false);

  const [currentJob, setCurrentJob] = useState(null);
  const [nextJob, setNextJob] = useState(null);
  const [holeJob, setHoleJob] = useState(null);
  const [onSchedule, setOnSchedule] = useState(0);

  const [tick, setTick] = useState(true);
  const [intervalId, setIntervalID] = useState(null);
  const intervalRef = useRef(null);
  const intervalTime = 60000;

  const machineList = cncService.machineDetailList[customer_id];
  const machineInfo =
    machineList == null || machineList == undefined
      ? undefined
      : machineList.find((x) => x["machine_id"] == machineId);

  const onSetAutoScroll = (val) => {
    UpdateAppConfig({ isAutoScroll: val }, props.dispatch);
  };

  const onClickMachine = (machine) => {
    onSetAutoScroll(false);
    setSelectedmachine(machine);
  };

  useEffect(() => {
    if (customer_id == null || customer_id === "" || customerInfo == undefined)
      return;

    readOperatorList((res) => {
      setOperatorList(res);
      if (intervalRef.current) clearInterval(intervalRef.current);
      const newIntervalId = setInterval(timer, intervalTime);
      intervalRef.current = newIntervalId;
      setIntervalID(newIntervalId);
    });

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      setIntervalID(null);
    };
  }, [customer_id]);

  useEffect(() => {
    readMachineGanttData();
  }, [tick]);

  const timer = () => {
    setTick((t) => !t);
  };

  useEffect(() => {
    getPartId(customer_id, (res) => {
      const { data, status, message } = res;
      if (status == false) {
        message.error(message);
        return;
      }
      setPartIds(data);
    });
  }, []);

  useEffect(() => {
    setSelectedmachine("");
    setPartId(partIds[machineId]);
    readMachineGanttData();
  }, [partIds, machineId]);

  useEffect(() => {
    setMachineId(machine_id);
    apiCallForGetMachineData();
  }, [machine_id]);

  useEffect(() => {
    if (machineInfo) {
      let ganttData = machineInfo["gantt"];

      if (ganttData && ganttData.length > 0) {
        let lastGanttData = ganttData[ganttData.length - 1];
        setCurrentJob(lastGanttData);
      }

      if (machineInfo["onSchedule"] != undefined) {
        setOnSchedule(machineInfo["onSchedule"]);
      } else {
        setOnSchedule(0);
      }

      let jobs = machineInfo["job_data"];

      if (!jobs || !Array.isArray(jobs)) {
        setHoleJob(null);
        setNextJob(null);
      } else {
        if (jobs.length > 1) {
          let holeJob = jobs[0];
          setHoleJob(holeJob);

          let nextJob = jobs[1];
          setNextJob(nextJob);
        }
        if (jobs.length == 1) {
          let nextJob = jobs[0];
          setNextJob(nextJob);
        }
      }
    } else {
      setCurrentJob(null);
      setNextJob(null);
      setHoleJob(null);
    }
  }, [machineInfo]);


  const readMachineGanttData = () => {
    const timeZone = customerInfo["timezone"];
    const customerCurrentTime = GetCustomerCurrentTime(timeZone);

    const startDate = moment(customerCurrentTime).format("MM/DD/YYYY");
    const endDate = moment(customerCurrentTime)
      .add(1, "days")
      .format("MM/DD/YYYY");

    GetMachineListDataMsd(
      customer_id,
      timeZone,
      startDate,
      endDate,
      machineId,
      dispatch
    );
  };

  function apiCallForGetMachineData() {
    let startDate = GetCustomerCurrentTime(timezone);
    startDate.setDate(startDate.getDate() - 30);
    startDate =
      pad(startDate.getMonth() + 1) +
      "/" +
      pad(startDate.getDate()) +
      "/" +
      pad(startDate.getFullYear());

    let endDate = GetCustomerCurrentTime(timezone);
    endDate.setDate(endDate.getDate() + 1);
    endDate =
      pad(endDate.getMonth() + 1) +
      "/" +
      pad(endDate.getDate()) +
      "/" +
      pad(endDate.getFullYear());

    setShowSpin(true);
    GetUtilizationDetailData(
      customer_id,
      customerInfo["timezone"],
      startDate,
      endDate,
      machine_id,
      1,
      (res) => {
        setShowSpin(false);
        if (res != null && res.data) {
          let uList = [...res.data.utilities];
          let tmpTotal = 0;
          uList.map((x, index) => {
            tmpTotal += parseFloat(x.utilization);
          });
          setMonthlyTotal(parseFloat(tmpTotal).toFixed(1));
          setMonthlyUtilizations(uList);
        }
      }
    );
  }

  if ((customerInfo == undefined || machineInfo) == undefined) {
    return (
      <div style={{ textAlign: "center", paddingTop: 100 }}>
        {" "}
        <Spin tip="Loading ..." size="large" />
      </div>
    );
  }

  return (
    <div>
      {selectedMachine == "" && (
        <div>
          <MachineItem
            machineInfo={machineInfo == undefined ? {} : machineInfo}
            customer_id={customer_id}
            customerInfo={customerInfo}
            onClickMachine={onClickMachine}
            operatorList={operatorList}
            screenSize={screenSize}
            partId={partId}
          />

          <JobCardsPresentation className="msd-jobs-container" currentJob={currentJob} nextJob={nextJob} holeJob={holeJob} onSchedule={onSchedule} />

          <div className="msd-monthly-utilization-container">
            <MonthlyUtilization
              screenSize={screenSize}
              monthlyTotal={monthlyTotal}
              monthlyUtilizations={monthlyUtilizations}
            />
          </div>

        </div>
      )}

      <CSSTransition
        in={selectedMachine !== ""}
        timeout={1000}
        classNames="pageSliderLeft"
        unmountOnExit={true}
      >
        <MachineDetailPage
          customer_id={customer_id}
          customerInfo={customerInfo}
          machineInfo={selectedMachine}
          security_level={security_level}
          onCloseMachine={setSelectedmachine}
          operatorList={operatorList}
          screenSize={screenSize}
          dismissible
        />
      </CSSTransition>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  cncService: state.cncService,
  app: state.app,
});
const mapDispatchToProps = (dispatch, props) => ({
  dispatch: dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(MachineScheduleDashboards);
